import React from 'react';
import * as Render from '../platformui/Base/Render';
import { ImageGallery } from '../platformui/ImageGallery';
import SlideshowImageBlock from './slideshow-image-block';

const Blocks = {
  SlideshowImageBlock,
};

const SlideShowBlock = (props) => {
  return (
    <ImageGallery
      {...props}
      Heading={Render.Property(props.Heading, 'Heading')}
      Images={
        <Render.Block
          blocks={props.MainContent}
          propertyName="MainContent"
          currentPageProps={props.CurrentPageProps}
        >
          <Render.BlockTypeRenderer Blocks={Blocks} />
        </Render.Block>
      }
      Dir={props.CurrentPageProps.Dir}
      NumOfImages={props.MainContent ? props.MainContent.length : 0}
      NonCollapsible={true}
    />
  );
};

export default SlideShowBlock;